import React, {useState, useEffect, useContext} from "react";
import { AuthContext } from "./AuthContext";
import { Navigate, Outlet } from "react-router-dom";


const PrivateRoutes = () => {
    const {isLoggedIn} = useContext(AuthContext);

    return isLoggedIn ? <Outlet/> : <Navigate to="/signin"/>
}

export default PrivateRoutes;
